<div class="notif-type-wrapper">
    <app-webiat-radio-card *ngIf="parentName === 'edit-profile'"
    [data]="ExpradioButtons"
    (selectedValueChanged)="onSelectedValueChanged($event)"
    ></app-webiat-radio-card>
    
    <app-webiat-radio-card *ngIf="parentName === 'collab-notif'"
    [data]="NotifradioButtons"
    (selectedValueChanged)="onSelectedValueChanged($event)"
    ></app-webiat-radio-card>
</div>